module.exports = __webpack_public_path__ + "img/services-six.33bb7ae5.png";